import React from 'react';
import PropTypes from 'prop-types';
import ContentPageStyled from '@glowforge/gf-styled/src/components/content-page.styled';
import HeadTitle from '../head/head-title';

import CountryNavigation from './country-navigation';
import {
  Wrapper,
  ContentWrapper,
  Heading,
  LegalMarkdown,
} from './legal-markdown.styles';

const LegalPage = ({ page }) => {
  const {
    title,
    legalContent,
    legalContentPart2,
    countryNavigationList,
    cookieLinkText,
  } = page.fields;

  const hasCountryNav = countryNavigationList?.length > 0;

  return (
    <ContentPageStyled>
      <Wrapper variant='full'>
        <HeadTitle title={title} />
        {hasCountryNav ? (
          <CountryNavigation
            countries={countryNavigationList}
            cookieLinkText={cookieLinkText}
          />
        ) : null}
        <ContentWrapper hasCountryNav={hasCountryNav}>
          <Heading>{title}</Heading>
          <LegalMarkdown
            className='termsMarkdown paragraph'
            source={`${legalContent || ''} ${legalContentPart2 || ''}`}
          />
        </ContentWrapper>
      </Wrapper>
    </ContentPageStyled>
  );
};

LegalPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  page: PropTypes.any.isRequired,
};

export default LegalPage;
